<template>
  <div
    v-if="isSpecialFolder"
    class="d-flex flex-column"
    data-locator="empty-state"
  >
    <!-- The min-height is based on the mockup, to force a vertical align -->
    <v-card class="d-flex flex-column align-center justify-center text-center" min-height="200">
      <app-icon-ds icon="file-lines" size="xl" class="mb-5" />
      <h3 class="mb-2" data-locator="empty-state-title">
        {{
          this.paginatedDocumentsCurrentFolderId === RECENT_FOLDER.id
          ? $t('project.documents.DocumentsEmptyState.noRecentFilesTitle')
          : $t('project.documents.DocumentsEmptyState.noTodoFilesTitle')
        }}
      </h3>
      <p
        class="text--small"
        data-locator="empty-state-text"
      >
        {{ $t('project.documents.DocumentsEmptyState.noFilesText') }}
      </p>
    </v-card>
  </div>
  <!-- Very unusual margin, but that's what the mockup shows -->
  <app-empty-state
    v-else
    class="mt-12"
    module="documents"
    translation-key-prefix="project.documents.DocumentsEmptyState"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import { RECENT_FOLDER } from '@/project/documents/constants/special-folders'

export default {
  name: 'DocumentsEmptyState',
  data () {
    return {
      RECENT_FOLDER,
    }
  },
  computed: {
    ...mapState('documents', ['paginatedDocumentsCurrentFolderId']),
    ...mapGetters('documentsBreadcrumb', ['hasTodoFolderOrChild']),
    isSpecialFolder () {
      return this.paginatedDocumentsCurrentFolderId === RECENT_FOLDER.id || this.hasTodoFolderOrChild
    },
  },
}
</script>
